import { render, staticRenderFns } from "./validScene.vue?vue&type=template&id=6f4059a8&scoped=true&"
import script from "./validScene.vue?vue&type=script&lang=js&"
export * from "./validScene.vue?vue&type=script&lang=js&"
import style0 from "./validScene.vue?vue&type=style&index=0&id=6f4059a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4059a8",
  null
  
)

export default component.exports